<div class="dialog">
  <h4 mat-dialog-title>{{ 'dialog_select_eu_share_title' | translate }}</h4>
  <form #form="ngForm">
    <div class="row">
      <div class="col">
        <mat-form-field>
          <mat-label color="accent">{{ 'common_field_user_entity_name' | translate }}</mat-label>
          <input matInput (keyup)="nameChanged($event.target)" />
        </mat-form-field>
      </div>
    </div>
    <div class="div-tree">
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
          <button mat-icon-button disabled></button>
          <mat-checkbox class="checklist-leaf-node" [checked]="checklistSelection.isSelected(node)" (change)="leafItemSelectionToggle(node)">{{ node.displayName }}</mat-checkbox>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: hasNoContent" matTreeNodePadding>
          <button mat-icon-button disabled></button>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.displayName">
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>
          <mat-checkbox [checked]="descendantsAllSelected(node)" [indeterminate]="descendantsPartiallySelected(node)" (change)="itemSelectionToggle(node)"> {{ node.displayName | translate }}</mat-checkbox>
        </mat-tree-node>
      </mat-tree>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onClickBack()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="onClickAdd()" color="accent">{{ 'common_btn_add' | translate }}</button>
    </div>
  </form>
</div>
